import { useEffect, useState } from "react";
import { activeAuthorsByTopic } from "../../../api/specialization/AuthorSpecializationAPI";
import { useSnackbar } from "notistack";
import { Chart, registerables } from "chart.js";
import { useTranslation } from "react-i18next";
import { errorNoti } from "../../../util/SnackbarMessage";
import AuthorCountComponent from "./AuthorCountComponent";
import ContentListPopup from "../../../components/popup/ContentListPopup";
import { List } from "@mui/material";

Chart.register(...registerables);
type TopicProps = {
  topic: string;
  days: number;
};

export function AuthorTopicChart(props: TopicProps) {
  var topic = props.topic;
  var days = props.days;
  const { t } = useTranslation(["common"]);
  const [authorStats, setAuthorStats] = useState([]);
  const [chosenAuthor, setChosenAuthor] = useState({ author: "", source: "" });
  const [popup, setPopup] = useState(false);
  const [sources, setSources] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const onClosePopup = () => {
    setPopup(false);
    setSources([]);
  };
  useEffect(() => {
    activeAuthorsByTopic(topic, days)
      .then((res) => setAuthorStats(res.slice(0, 15)))
      .catch((err) => {
        var noti = errorNoti(err);
        enqueueSnackbar(t("error:" + noti.message), noti.option);
      });
  }, [topic, days]);

  var maxCount = authorStats.length > 0 ? authorStats[0]["points"] : 1;
  var elements = authorStats.slice(0, 5).map((stat) => {
    return (
      <div
        onClick={() => {
          setChosenAuthor(stat);
          setPopup(true);
        }}
      >
        <AuthorCountComponent
          name={stat["author"]}
          source={stat["source"]}
          count={stat["points"]}
          scaledNumber={stat["points"] / maxCount}
          color="error"
        />
      </div>
    );
  });

  return (
    <div>
      <List>{elements}</List>
      <ContentListPopup
        popup={popup}
        onClosePopup={onClosePopup}
        contents={sources}
        title={
          "Các bài báo gần đây của tác giả " +
          chosenAuthor["author"] +
          " - " +
          chosenAuthor["source"]
        }
      />
    </div>
  );
}
